import React from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const inputCls = "w-full border border-gray-300 rounded-sm px-3 py-2 text-[14px] outline-none focus:border-[#16345c]";
const labelCls = "block text-[12px] font-semibold text-gray-600 mb-1";

export const CONTRACT_TYPES = [
  { v: "ti", l: "Tempo indeterminato" },
  { v: "td", l: "Tempo determinato" },
  { v: "app", l: "Apprendistato" },
  { v: "cococo", l: "Collaborazione coordinata (co.co.co.)" },
  { v: "piva", l: "Partita IVA" },
];
export const isAutonomo = (t) => t === "cococo" || t === "piva";

const Pick = ({ value, onChange, options, testid, placeholder = "Non indicato" }) => (
  <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
    <SelectTrigger data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      <SelectItem value="none">{placeholder}</SelectItem>
      {options.map((o) => <SelectItem key={o.v} value={o.v}>{o.l}</SelectItem>)}
    </SelectContent>
  </Select>
);

const TfrFields = ({ form, set }) => (
  <>
    <div>
      <label className={labelCls}>Destinazione TFR</label>
      <Pick value={form.tfr_destination} onChange={(v) => set({ tfr_destination: v })} testid="emp-tfr-destination"
        options={[{ v: "azienda", l: "In azienda" }, { v: "fondo", l: "Fondo (previdenza complementare / Tesoreria INPS)" }]} />
    </div>
    <div>
      <label className={labelCls}>Saldo TFR di partenza (€)</label>
      <input type="number" min="0" step="0.01" value={form.tfr_base_amount ?? ""} placeholder="dal cedolino" data-testid="emp-tfr-base-amount"
        onChange={(e) => set({ tfr_base_amount: e.target.value })} className={inputCls} />
    </div>
    <div>
      <label className={labelCls}>Data del saldo TFR</label>
      <input type="date" value={form.tfr_base_date || ""} data-testid="emp-tfr-base-date" onChange={(e) => set({ tfr_base_date: e.target.value })} className={inputCls} />
    </div>
    <p className="sm:col-span-2 text-[11px] text-gray-400 -mt-1">
      Export: saldo + RAL/13,5 pro-rata fino alla data di riferimento (senza saldo, stima dall'assunzione). Con destinazione "fondo" conta solo il TFR rimasto in azienda (saldo indicato).
    </p>
  </>
);

// Campi anagrafici per l'Export Due Diligence (tipo rapporto, cognome, TFR, causale TD, rischio riqualificazione).
export const DdEmployeeFields = ({ form, setForm }) => {
  const set = (patch) => setForm({ ...form, ...patch });
  const auto = isAutonomo(form.contract_type);
  return (
    <div className="sm:col-span-2 border-t border-gray-100 pt-3 grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="emp-dd-fields">
      <div className="sm:col-span-2 text-[12.5px] font-bold text-[#16345c]">Rapporto di lavoro e Due Diligence</div>
      <div>
        <label className={labelCls}>Tipo rapporto</label>
        <Pick value={form.contract_type} onChange={(v) => set({ contract_type: v })} options={CONTRACT_TYPES} testid="emp-contract-type" />
      </div>
      <div>
        <label className={labelCls}>Cognome <span className="text-gray-400 font-normal">(facoltativo, per "Cognome Nome")</span></label>
        <input value={form.last_name || ""} placeholder="es. De Luca" data-testid="emp-last-name" onChange={(e) => set({ last_name: e.target.value })} className={inputCls} />
      </div>
      {form.contract_type === "td" && (
        <div>
          <label className={labelCls}>Causale valida oltre i 12 mesi</label>
          <Pick value={form.td_causale == null ? "" : form.td_causale ? "si" : "no"} testid="emp-td-causale"
            onChange={(v) => set({ td_causale: v === "" ? null : v === "si" })} options={[{ v: "si", l: "Sì" }, { v: "no", l: "No" }]} />
        </div>
      )}
      {auto && (
        <div>
          <label className={labelCls}>Rischio riqualificazione</label>
          <Pick value={form.requalification_risk} onChange={(v) => set({ requalification_risk: v })} testid="emp-requalification-risk"
            options={[{ v: "basso", l: "Basso" }, { v: "medio", l: "Medio" }, { v: "alto", l: "Alto" }]} />
        </div>
      )}
      {!auto && <TfrFields form={form} set={set} />}
    </div>
  );
};

// Normalizza i campi DD per il payload API ("" → null, numeri).
export const ddPayload = (f) => ({
  contract_type: f.contract_type || null,
  last_name: f.last_name || null,
  tfr_destination: f.tfr_destination || null,
  tfr_base_amount: f.tfr_base_amount === "" || f.tfr_base_amount == null ? null : Number(f.tfr_base_amount),
  tfr_base_date: f.tfr_base_date || null,
  td_causale: f.td_causale == null ? null : !!f.td_causale,
  requalification_risk: f.requalification_risk || null,
});

export default DdEmployeeFields;
